import type { H3Event } from 'h3'
import { getCookie } from '../openfeature/utils'

export const INTEREST_COOKIE = 'qz_interest'

const INTEREST_COOKIE_PATTERN = /^([a-f0-9]{24})\.([a-z0-9-]{1,100})$/

export type InterestCookie = {
  interest: string
  catalogVersion: string
}

export function formatInterestCookie({
  interest,
  catalogVersion,
}: InterestCookie): string {
  return `${interest}.${catalogVersion}`
}

export function parseInterestCookie(
  value: string | null
): InterestCookie | null {
  const match = value?.match(INTEREST_COOKIE_PATTERN)
  if (!match) return null
  return { interest: match[1], catalogVersion: match[2] }
}

export function interestFromRequest(event: H3Event): InterestCookie | null {
  return parseInterestCookie(getCookie(event, INTEREST_COOKIE))
}
